import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/features/auth/AuthProvider';

export function UserMenu() {
  const { state, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (state.status !== 'authenticated') return null;
  const { user } = state.current;

  return (
    <div className="relative" data-testid="user-menu">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded px-2 py-1 text-sm hover:bg-[color:var(--color-muted)]"
        data-testid="user-menu-button"
        aria-label={`User menu for ${user.display_name}`}
      >
        <span
          className="grid h-7 w-7 place-items-center rounded-full bg-[color:var(--color-primary)] text-xs font-bold text-[color:var(--color-primary-foreground)] sm:hidden"
          aria-hidden="true"
        >
          {(user.display_name || user.email || '?').slice(0, 1).toUpperCase()}
        </span>
        <span className="hidden font-medium sm:inline">{user.display_name}</span>
        {user.is_super_admin ? (
          <span className="rounded bg-[color:var(--color-accent)] px-1.5 py-0.5 text-[10px] font-bold uppercase text-[color:var(--color-accent-foreground)]">
            super
          </span>
        ) : null}
      </button>
      {open ? (
        <div className="absolute right-0 mt-1 w-64 rounded border border-[color:var(--color-border)] bg-popover p-2 shadow-lg max-w-[calc(100vw-1.5rem)]">
          <p className="px-2 py-1 text-xs text-[color:var(--color-fg)]/60">{user.email}</p>
          {user.is_super_admin ? (
            // Single gateway into the dedicated /admin area (which has its own
            // full platform-admin sidebar) — keeps admin out of the operational
            // left nav and avoids duplicating those links here.
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                navigate('/admin/usage');
              }}
              className="w-full rounded px-2 py-1 text-left text-sm font-medium hover:bg-[color:var(--color-muted)]"
              data-testid="user-menu-admin"
            >
              Platform admin →
            </button>
          ) : null}
          <button
            type="button"
            onClick={async () => {
              setOpen(false);
              await logout();
              navigate('/login');
            }}
            data-testid="user-menu-logout"
            className="w-full rounded px-2 py-1 text-left text-sm hover:bg-[color:var(--color-muted)]"
          >
            Sign out
          </button>
        </div>
      ) : null}
    </div>
  );
}
